"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BEHAVIOR = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _clsx = _interopRequireDefault(require("clsx"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ExpansionPanel = _interopRequireDefault(require("@material-ui/core/ExpansionPanel"));

var _ExpansionPanelDetails = _interopRequireDefault(require("@material-ui/core/ExpansionPanelDetails"));

var _ExpansionPanelSummary = _interopRequireDefault(require("@material-ui/core/ExpansionPanelSummary"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("../../elements/Typography"));

var _ExpanderCss = _interopRequireDefault(require("./Expander.css.js"));

var BEHAVIOR = {
  default: 'default',
  controlled: 'controlled'
};
/**
 * This class is an adaptation of the ExpansionPanel class from Material UI.
 *
 * Possibly the name may be better to be the same as that of Material UI?
 */

exports.BEHAVIOR = BEHAVIOR;

var Expander =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Expander, _React$PureComponent);

  function Expander() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Expander);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Expander)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      expanded: _this.props.expanded || false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "secondaryIcon", function (secondaryActionIcon) {
      switch (secondaryActionIcon) {
        case 'add':
          return React.createElement(_Add.default, null);

        default:
          return null;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (event, expanded) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          behavior = _this$props.behavior;

      if (behavior === BEHAVIOR.default) {
        _this.setState({
          expanded: expanded
        });
      }

      if (onChange) {
        onChange(expanded);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSecondaryAction", function (event) {
      var secondaryAction = _this.props.secondaryAction;

      if (secondaryAction) {
        event.stopPropagation();
        secondaryAction();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Expander, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          expanded = _this$props2.expanded,
          behavior = _this$props2.behavior;

      if (behavior === BEHAVIOR.default && prevProps.expanded !== expanded) {
        this.setState({
          expanded: expanded
        });
      }
    }
    /**
     * Our class accepts only a specific set of strings that
     * correspond to an icon to output.
     * This function coverts these strings to the icon that
     * will be displayed.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          arrowRight = _this$props3.arrowRight,
          behavior = _this$props3.behavior,
          children = _this$props3.children,
          classes = _this$props3.classes,
          contentOffset = _this$props3.contentOffset,
          expandedProp = _this$props3.expanded,
          header = _this$props3.header,
          secondaryAction = _this$props3.secondaryAction,
          secondaryActionIcon = _this$props3.secondaryActionIcon;
      var expandedState = this.state.expanded;
      var expanded = behavior === BEHAVIOR.default ? expandedState : expandedProp;
      return React.createElement(_ExpansionPanel.default, {
        expanded: expanded,
        onChange: this.handleChange,
        classes: {
          expanded: classes.expanderExpanded,
          root: classes.expanderRoot
        }
      }, React.createElement(_ExpansionPanelSummary.default, {
        "aria-controls": "expander-content",
        id: "expander-header",
        classes: {
          expanded: classes.expansionPanelSummaryExpanded,
          content: classes.expansionPanelSummaryContent,
          root: classes.expansionPanelSummaryRoot
        }
      }, !arrowRight && React.createElement("div", {
        className: classes.buttonContainer
      }, React.createElement("div", {
        className: classes.buttonSubContainer
      }, React.createElement(_IconButton.default, {
        classes: {
          root: classes.buttonRoot
        }
      }, React.createElement(_ExpandMore.default, {
        classes: {
          root: (0, _clsx.default)(classes.iconRoot, expanded && 'rotated')
        }
      })))), React.createElement(_Typography.default, {
        variant: "body1",
        className: classes.headerTypographyRoot
      }, header), (secondaryAction || arrowRight) && React.createElement("div", {
        className: classes.buttonContainer
      }, React.createElement("div", {
        className: (0, _clsx.default)(classes.buttonSubContainer)
      }, React.createElement(_IconButton.default, {
        classes: {
          root: classes.buttonRoot
        },
        onClick: this.handleSecondaryAction
      }, arrowRight ? React.createElement(_ExpandMore.default, {
        classes: {
          root: (0, _clsx.default)(classes.iconRoot, expanded && 'rotated')
        }
      }) : this.secondaryIcon(secondaryActionIcon))))), React.createElement(_ExpansionPanelDetails.default, {
        classes: {
          root: (0, _clsx.default)(classes.content, contentOffset && 'offset')
        }
      }, React.createElement(_Typography.default, {
        variant: "body2",
        fullWidth: true
      }, children)));
    }
  }]);
  return Expander;
}(React.PureComponent);

Expander.defaultProps = {
  arrowRight: false,
  behavior: BEHAVIOR.default,
  contentOffset: true,
  expanded: false
};
Expander.propTypes = {
  /**
   * Whether the arrow is on the right or not.
   * Defaults to false.
   */
  arrowRight: PropTypes.bool.isRequired,

  /**
   */
  behavior: PropTypes.oneOf(Object.keys(BEHAVIOR)),

  /**
   * Content displayed in the body of the expander.
   */
  children: PropTypes.node.isRequired,

  /**
   * Whether the content is offset by the width of the arrow or not.
   * Defaults to false.
   */
  contentOffset: PropTypes.bool.isRequired,

  /**
   * Whether the component is expanded or not.
   */
  expanded: PropTypes.bool,

  /**
   * Header of the expander.
   */
  header: PropTypes.node.isRequired,

  /**
   * Action taken when either the component is expanded or collapsed.
   */
  onChange: PropTypes.func,

  /**
   * Action taken when the secondaryActionIcon is clicked.
   */
  secondaryAction: PropTypes.func,

  /**
   * Type of secondary action icon that appears in the top-right of the component.
   */
  secondaryActionIcon: PropTypes.oneOf(['add'])
};

var _default = (0, _styles.withStyles)(_ExpanderCss.default)(Expander);

exports.default = _default;